import { strapiImageGetters } from '~/utils/strapiImageGetters'
import type { StrapiKftBanner } from '~/composables/types/strapi/common'
import type { StrapiApiDefaultResponse } from '~/composables/types/strapi-api'

export const useBannerFromStrapi = async (
  pagekey: string,
  defaults = {}
): any => {
  const { locale } = useI18n()
  const { data: bannerDetails, refresh: loadBanners } =
    await useStrapiSingleType<
      StrapiApiDefaultResponse<StrapiKftBanner[]>,
      StrapiKftBanner[]
    >(
      'banners' +
        `?locale=${locale.value}` +
        '&pLevel=5' +
        `&filters[pagekey][$eq]=${pagekey}`,
      {
        lazy: true,
        server: false,
        transform: (data) => {
          return data?.data || []
        },
        default: () => [],
      }
    )

  const bannerData = computed(() => {
    const [bannerData = {}] = bannerDetails?.value || []
    return {
      ...defaults,
      ...(defaults?.subtitle ? { description: defaults.subtitle } : {}),
      ...bannerData,
      bgImg: strapiImageGetters.getImageUrl(bannerData?.bgImage),
      bgImageMobile: strapiImageGetters.getImageUrl(bannerData?.bgImageMobile),
      bannerFeaturedMedia: (bannerData?.featuredMedia || []).map((mb) => ({
        ...mb,
        src: strapiImageGetters.getImageUrl(mb?.media),
        text: mb.title || '',
        url: mb.url || '',
        alt: strapiImageGetters.getAlternativeText(mb.media),
      })),
    }
  })

  return {
    bannerData,
    bannerFeaturedMedia: bannerData?.value?.bannerFeaturedMedia || [],
    loadBanners,
  }
}
